<!-- <section > -->
  <article class="logo-edit">
    <div class="logo-editor-canvas">
      <div class="zoom-buttons" *ngIf="1 > editor.scaleFactor" >
        <core-helpers-forms-zoom-buttons
            [hidden]="!imgLoaded || working"
            [inStep]="0.1"
            [outStep]="-0.1"
            (out)="editor.setZoom($event)"
            (in)="editor.setZoom($event)"
            [inDisabled]="editor.zoom.relative==1"
            [outDisabled]="editor.zoom.relative==0"
        ></core-helpers-forms-zoom-buttons>
      </div>

      <div #drag
        class="drag"
        coreSizeMe
        [monitorWidth]="true"
        [monitorHeight]="true"
        (resize)="resizeArea($event)"
        [ngClass]="{loading: !imgLoaded || working }"
        >
        <core-helpers-box-loading [hidden]="imgLoaded"></core-helpers-box-loading>
        <img
          *ngIf="urlImage!=null"
          [hidden]="!imgLoaded || working"
          [src]="urlImage"
          alt="profile image"
          (load)="imageLoaded($event)"
          draggable="false"
          (mousemove)="editor.drag('move', $event)"
          (mousedown)="editor.drag('start', $event)"
          (mouseup)="editor.drag('stop', $event)"
          (mouseleave)="editor.drag('stop', $event)"
          [ngStyle]="editor.styles.image"
        />
      </div>
    </div>
  <fieldset>
    <core-helpers-forms-button [type]="'grey'" [text]="'GO BACK'" [disabled]="false" (click)="onCancel()"></core-helpers-forms-button>
    <core-helpers-forms-button-white [text]="'Save'" [disabled]="!imgLoaded" (click)="submit()"></core-helpers-forms-button-white>
  </fieldset>
</article>
<!-- </section> -->
